import { ChannelTypeInternal } from '../../../../../data-access/gql-types/graphql';

export const configurationExists = [
  ChannelTypeInternal.Switch,
  ChannelTypeInternal.Blind,
  ChannelTypeInternal.Gate,
  ChannelTypeInternal.Light,
  ChannelTypeInternal.Meter,
];
